import AssessmentApiCall from 'ASSESSMENT/AssessmentApiCall';
import SuccessModal from 'ASSESSMENT/CommonResources/SuccessModal/SuccessModal';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import 'ASSESSMENT/Components/ResultList/resultlist.css';
import Spinner from 'ASSESSMENT/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import ResultDetails from './ResultDetails/ResultDetails';

class ResultList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isResultFetching: false,
            resultList: [],
            sortedIdArray: [],
            instituteName: '',
            instituteLogo: '',
            pageIndex: 1,
            limit: 10,
            total: 0,
            offset: 0,
            filterAcademicYear: '',
            filterDepartment: '',
            instituteUrl: this.props.match.params.instituteUrl,
            isValidUrl: '',

            // VARIABLES TO VIEW RESULT
            viewResult: false,
            uniqueResultId: '',
            resultTitle: '',
            customColumnConfiguration: [],
            averageGradePointTitle: '',

            // VARIABLES FOR SUCCESS MODAL
            successModal: false, 
            successModalType:'',
            successMessage:''
        };
    }

    componentDidMount () {
        // METHOD CALLED TO MAKE API CALL TO GET RESULT LIST
        this.apiCallToGetResultList();
    }

    // API CALL METHOD TO GET RESULT LIST
    apiCallToGetResultList = async () => {
        this.setState({
            isResultFetching: true
        });

        let requestData = {
            "institute_url": this.state.instituteUrl,
            "aca_yr": this.state.filterAcademicYear,
            "sid": this.state.filterDepartment,
            "page_index": this.state.pageIndex,
            "limit": this.state.limit
        };

        let jsonResponse = await AssessmentApiCall.makeAssessmentApiCall(
            'getResultListForPublicPage',
            requestData,
            '/api/assessment/publicLink.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetResultList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    instituteLogo: apiResult.InstituteLogo,
                    instituteName: apiResult.InstituteName,
                    resultList: apiResult.resultList,
                    sortedIdArray: jsonResponse.APIResult.sortedIdArray,
                    isResultFetching: false,
                    total: jsonResponse.APIResult.totalCount,
                    isValidUrl: jsonResponse.APIResult.isValidUrl == 'true' ? true : false
                });
                document.content = ReactHtmlParser(apiResult.InstituteName);
            } else {
                this.setState({
                    isResultFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting institute result list. Please try again later.'
                });
            }
        }
    }
    
    // METHOD TO UPDATE PAGINATION COUNT
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit
        }, () => {
            this.apiCallToGetResultList();
        });
    }

    // METHOD TO CLOSE VIEW RESULT
    closeViewResult = () => {
        this.setState({
            viewResult: false
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    render() {
        return(
            <>
                {
                    this.state.isValidUrl ?
                        <>
                            <div className="componentContainer">
                                {
                                    this.state.viewResult ?
                                        <ResultDetails
                                            resultId={this.state.uniqueResultId}
                                            resultTitle={this.state.resultTitle}
                                            customColumnConfiguration={this.state.customColumnConfiguration}
                                            averageGradePointTitle={this.state.averageGradePointTitle}
                                            instituteUrl={this.state.instituteUrl}
                                            instituteLogo={this.state.instituteLogo}
                                            instituteName={this.state.instituteName}
                                            closeViewResult={this.closeViewResult}
                                        />
                                    :
                                    this.state.isResultFetching ?
                                        <Spinner />
                                    :
                                        <>
                                            <div className="collegeInfo col-md-12">
                                                <div className="college-logo">
                                                    <img className="collegeLogo" src={this.state.instituteLogo} alt="institute-logo" />
                                                </div>
                                                <div className="college-name">
                                                    <h3>{ReactHtmlParser(this.state.instituteName)}</h3>
                                                </div>
                                            </div>
                                            <div className="resultList">
                                                <div className="resultTable col-md-10">
                                                    <table className="table table-bordered table-responsive-sm">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ padding: 10 }}>Sr. No.</th>
                                                                <th style={{ padding: 10 }}>Result</th>
                                                                <th style={{ padding: 10 }}></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                Object.keys(this.state.resultList).length > 0 ?
                                                                    this.state.sortedIdArray.map((resultId, index) => {
                                                                        let result = this.state.resultList[resultId];
                                                                        return(
                                                                            <tr key={result.uniqueId}>
                                                                                <td style={{ padding: 10 }}>{this.state.offset + index + 1}.</td>
                                                                                <td className="resultTitle" style={{ padding: 10 }}>{result.title}</td>
                                                                                <td style={{ padding: 10 }}><span style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }} title='Click to view result' onClick={() => this.setState({ uniqueResultId: result.uniqueId, viewResult: true, resultTitle: result.title, customColumnConfiguration: result.customColumnConfiguration, averageGradePointTitle: result.averageGradePointTitle })}>View Result</span></td>
                                                                            </tr>
                                                                        );
                                                                    })
                                                                :
                                                                    <tr>
                                                                        <td colSpan="3">No results yet published for the institute.</td>
                                                                    </tr>
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {
                                                Object.keys(this.state.resultList).length > 0 &&
                                                <div id="paginationContainer">
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.total}
                                                        pageRangeDisplayed={3}
                                                        onChange={(num) => this.updatePaginationCount(num)}
                                                    />
                                                </div>
                                            } 
                                        </>
                                }
                            </div>
                            {
                                this.state.successModal &&
                                    <SuccessModal 
                                        successModal={this.state.successModal} 
                                        successModalType={this.state.successModalType}
                                        successMessage={this.state.successMessage}
                                        closeSuccessModal={this.closeSuccessModal} 
                                    />
                            }
                        </>
                    :
                        <div className="invalid-url">
                            <p>Invalid URL.</p>
                        </div>
                }
            </>
        );
    }
}

export default ResultList;